import React from 'react';
import { connect } from 'react-redux';
import Head from 'next/head';
import { getFavIcon } from '../src/scripts/utils/getFavIcon';

// import "../node_modules/slick-carousel/slick/slick.css";
// import "../node_modules/slick-carousel/slick/slick-theme.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import '../src/styles/index.styl';
import Photo from '../src/scripts/containers/photoConnect';
import { requestMedia, requestMedias, requestEvent } from '../src/scripts/actions/actions';

class PhotoPage extends React.Component {
  static async getInitialProps({ isServer, store, query, req }) {
    const { eventId } = query;
    const { photoId } = query;
    const beta = query.betaFeatures && query.betaFeatures === 'true';
    const { booth } = query;
    let photoPosition = null;

    if (isServer) {
      const domain = req.headers.host;
      let subdomain = '';
      if (domain) {
        const url = domain.split('.');
        if (url.length > 2 && !['dev', 'beta', 'staging', 'www'].includes(url[0])) {
          subdomain = url[0];
        }
      }

      photoPosition = query.photoPosition;

      store.dispatch(requestEvent(eventId, isServer, subdomain));

      if (photoId) {
        store.dispatch(requestMedia(photoId, eventId, subdomain));
      }
    }

    if (!photoId) {
      store.dispatch(requestMedias(eventId));
    }

    return { eventId, photoId, beta, isServer, photoPosition, booth };
  }

  componentDidMount() {
    document.documentElement.classList.remove('preload');
  }

  render() {
    const { pageType, eventId, photoId, isServer, photoPosition, beta, eventTitle, booth } = this.props;
    const screen = beta ? 'screen-beta' : 'screen';

    return (
      <div className={screen}>
        <Head>
          <title>{eventTitle}</title>
          {getFavIcon('blank')}
        </Head>
        <div>
          <Photo
            eventId={eventId}
            photoId={photoId}
            beta={beta}
            isServer={isServer}
            photoPosition={photoPosition}
            booth={booth}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  pageType: state.pageType,
  fontColor: state.activeEvent.fontColor,
  backgroundColor: state.activeEvent.backgroundColor,
  contactEnabled: state.activeEvent.contactEnabled,
  contactOwner: state.activeEvent.contactOwner,
  fullGalleryEnabled: state.activeEvent.fullGalleryEnabled,
  eventTitle: state.activeEvent.title,
});

export default connect(mapStateToProps)(PhotoPage);
